import './lncanada8/style';
import FormStructure from './lncanada8/form_structure';

export default FormStructure;